const trainData = {
    success: true,
    data: {
        windows: [
            {
                id: 1,
                date: {
                    day: 25,
                    month: 12,
                },
                src: "./img/bozic-1.jpg",
                style: "w-[380px] h-[493.5px] lg:w-[462px] lg:h-[600px]",
            },
            {
                id: 2,
                date: {
                    day: 26,
                    month: 12,
                },
                src: "./img/bozic-2.jpg",
                style: "w-[380px]  h-[285px] lg:w-[600px] lg:h-[450px]",
            },
            {
                id: 3,
                date: {
                    day: 27,
                    month: 12,
                },
                src: "./img/bozic-3.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 4,
                date: {
                    day: 28,
                    month: 12,
                },
                src: "./img/bozic-4.jpg",
                style: "w-[380px] h-[506px] lg:w-[450px] lg:h-[600px]",
            },
            {
                id: 5,
                date: {
                    day: 29,
                    month: 12,
                },
                src: "./img/bozic-5.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 6,
                date: {
                    day: 30,
                    month: 12,
                },
                src: "./img/bozic-6.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 7,
                date: {
                    day: 31,
                    month: 12,
                },
                src: "./img/bozic-7.jpg",
                style: "w-[225px] h-[500px] lg:w-[270px] lg:h-[600px]",
            },
            {
                id: 8,
                date: {
                    day: 1,
                    month: 1,
                },
                src: "./img/bozic-8.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 9,
                date: {
                    day: 2,
                    month: 1,
                },
                src: "./img/bozic-9.jpg",
                style: "w-[285px] h-[500px] lg:w-[342px] lg:h-[600px]",
            },
            {
                id: 10,
                date: {
                    day: 3,
                    month: 1,
                },
                src: "./img/bozic-10.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 11,
                date: {
                    day: 4,
                    month: 1,
                },
                src: "./img/bozic-11.jpg",
                style: "w-[380px] h-[171px] lg:w-[600px] lg:h-[270px]",
            },
            {
                id: 12,
                date: {
                    day: 5,
                    month: 1,
                },
                src: "./img/bozic-12.jpg",
                style: "w-[380px] h-[411px]  lg:w-[555px] lg:h-[600px]",
            },
        ],
    },
};

export default trainData;
